export const RelationshipEnum = {
  CHILD: { value: 'CHILD', content: 'Enfant' },
  GRANDCHILD: { value: 'GRANDCHILD', content: 'Petit-enfant' },
  GREAT_GRANDCHILD: { value: 'GREAT_GRANDCHILD', content: 'Arrière petit-enfant' },
  BROTHER: { value: 'BROTHER', content: 'Frère' },
  SISTER: { value: 'SISTER', content: 'Sœur' },
  FRIEND: { value: 'FRIEND', content: 'Ami' },
  OTHER: { value: 'OTHER', content: 'Autre' },
}
